
import React from 'react';

const GameDescription = () => {
  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl overflow-hidden">
        <div className="p-6 sm:p-10">
          <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-8">
            About Pokemon Clicker 2
          </h2>
          
          <div className="prose prose-lg max-w-none dark:prose-invert">
            <p>
              <strong>Pokemon Clicker 2</strong> is an exciting free online game that combines the beloved Pokemon universe with the addictive mechanics of idle clicker games. As a spiritual successor to the original Pokemon Clicker, this enhanced version brings more Pokemon, better gameplay, and a more satisfying progression system to fans of the franchise and clicker games alike.
            </p>
            
            <p>
              In <strong>Pokemon Clicker 2</strong>, you embark on a journey through the vibrant world of Pokemon, starting with a basic creature and gradually building a powerful collection through strategic clicking and resource management. The game captures the essence of Pokemon—catching, training, evolving, and battling—while adapting it to the simple yet engaging clicker format.
            </p>
            
            <p>
              The core gameplay loop revolves around clicking to capture wild Pokemon, which earn you points and currency. These resources can then be invested into upgrades that increase your clicking power, unlock automatic clicking abilities, and enhance your chances of encountering rare Pokemon. As you progress, you'll evolve your Pokemon into stronger forms, battle against gym leaders, and complete challenging quests.
            </p>

            <p>
              What makes <strong>Pokemon Clicker 2</strong> stand out from other clicker games is its faithful recreation of the Pokemon experience. Each Pokemon has unique stats and abilities that affect your clicking efficiency. The evolution system mirrors the main Pokemon games, giving players that same thrill of watching their beloved creatures transform into more powerful forms. The game also features a Pokedex that tracks your collection progress, giving completionists a clear goal to work toward.
            </p>
            
            <p>
              Whether you're a long-time Pokemon fan or new to the franchise, <strong>Pokemon Clicker 2</strong> offers an accessible way to experience the joy of Pokemon collecting without the complexity of the main series games. It's perfect for quick gaming sessions during breaks or for longer strategic sessions as you optimize your Pokemon team and clicking strategy.
            </p>

            <p>
              Best of all, <strong>Pokemon Clicker 2</strong> is completely free to play online, with no downloads required. Simply open your browser and start your Pokemon clicking adventure immediately. The game saves your progress automatically, allowing you to continue your journey whenever you have free time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GameDescription;
